
import axios from "axios"
import router from '../../router';

import { func } from '../../main';



const state = {
    OrgJobList:[],
    OrgJobNo: "",
    OrgJobNodes: [],
    Loading:false
};


const getters = {
    GetOrgJobList(state: { OrgJobList: any; }) {
        return state.OrgJobList;
    },
    GetOrgJobNodes(state: { OrgJobNodes: any; }) {
        return state.OrgJobNodes;
    },
    GetOrgJobNo(state: { OrgJobNo: any; }) {
        return state.OrgJobNo;
    },
};

const mutations = {

    SetOrgJobList(state: { OrgJobList: any; }, list: any) {
        state.OrgJobList = list;
    },
    SetOrgJobNodes(state: { OrgJobNodes: any; }, list: any) {
        state.OrgJobNodes = list;
    },
   
    SetOrgJobNo(state: { OrgJobNo: any; }, no: any) {
        state.OrgJobNo = no;
    },
  
};

const actions = {
   
    GetOrgJobListFromServer(context: { commit: (arg0: string, arg1: boolean) => void; }, Filter: { searchKey: any; } | null) {
        if (Filter == null) {
            Filter = { searchKey:"" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("OrgUnit/GetOrgJobListForUser", {
            params: {
                text: Filter.searchKey
            }
        })
           .then((data: any) => {
                context.commit("SetLoading", false);
                context.commit("SetOrgJobList", data.data);
            });
    },
    GetOrgJobNodesFromServer(context: { commit: (arg0: string, arg1: boolean) => void; }) {
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("OrgUnit/GetOrgJobNodes", {
        })
            .then((data: any) => {
                context.commit("SetLoading", false);
                context.commit("SetOrgJobList", data.data);
            });
    },
    ClearOrgJobList(context: { commit: (arg0: string, arg1: never[]) => void; }) {
        context.commit("SetOrgJobList", []);
    },
   
    CreateOrgJob(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);

        axios.post('OrgUnit/OrgJobCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                router.push('/OrgJobList');
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditOrgJob(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);

        axios.post('OrgUnit/OrgJobCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                router.push('/OrgJobList');
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
